import { render, staticRenderFns } from "./CategorieFichier.vue?vue&type=template&id=5dfe66cf&scoped=true"
import script from "./CategorieFichier.vue?vue&type=script&lang=js"
export * from "./CategorieFichier.vue?vue&type=script&lang=js"
import style0 from "./CategorieFichier.vue?vue&type=style&index=0&id=5dfe66cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfe66cf",
  null
  
)

export default component.exports